/*
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */

// Enable click-and-drag horizontal scrolling with the mouse on any `.scroller` element
(function() {
  var scroller = null;
  var startX = 0;
  var startScrollLeft = 0;
  var isDragging = false;
  var didDrag = false;

  document.addEventListener('mousedown', function(event) {
    var target = event.target.closest && event.target.closest('.scroller');
    if (!target || event.button !== 0) return;

    scroller = target;
    isDragging = true;
    didDrag = false;
    startX = event.pageX;
    startScrollLeft = scroller.scrollLeft;

    // Prevent native image/link drag-ghost and text selection from hijacking the gesture,
    // but keep native focus behavior on actual form controls.
    if (!event.target.closest('input, textarea, select, button')) {
      event.preventDefault();
    }
  });

  document.addEventListener('mousemove', function(event) {
    if (!isDragging || !scroller) return;

    var deltaX = event.pageX - startX;
    if (Math.abs(deltaX) > 3) {
      // Only now commit to "dragging": disables pointer-events on children so the
      // in-progress gesture isn't absorbed by a link/image, without affecting plain clicks.
      if (!didDrag) scroller.classList.add('scroller--dragging');
      didDrag = true;
    }
    scroller.scrollLeft = startScrollLeft - deltaX;
    event.preventDefault();
  });

  function stopDragging() {
    if (scroller) scroller.classList.remove('scroller--dragging');
    isDragging = false;
    scroller = null;
  }

  document.addEventListener('mouseup', stopDragging);
  document.addEventListener('mouseleave', stopDragging);

  // Prevent the drag release from being interpreted as a click on links/buttons inside the scroller
  document.addEventListener('click', function(event) {
    if (!didDrag) return;
    event.preventDefault();
    event.stopPropagation();
    didDrag = false;
  }, true);
})();
